import React from 'react';

import PropTypes from 'prop-types';

import { URL_PLACEHOLDER } from 'apps/promo/constants/UrlConstants';

import styles from './BlogTile.module.css';
import { Date } from '../date/Date';
import { PromoBadge } from '../promo-badge/PromoBadge';
import { PromoDangerouslyHtml } from '../promo-dangerously-html/PromoDangerouslyHtml';
import { PromoRow } from '../PromoRow/PromoRow';

export const BlogTile = (props) => {
    const imgPlaceholder = URL_PLACEHOLDER + `/blog-and-news-placeholder@2x.png`;

    const containerClassName = `${styles.tileBlogContainer} ${props.isNewsPage ? styles.newsPage : ''}`;

    return (
        <a href={props.link} className={containerClassName} data-testid="tile-blog-container">
            <div className={styles.imgContainer}>
                <img src={props.img && props.img.url ? props.img.url : imgPlaceholder} alt={props.img?.alternativeText} loading={'lazy'} decoding={'async'} />
            </div>
            {props.title && (
                <div className={styles.tileBlogContent}>
                    {props.date && (
                        <PromoRow indent="adaptive-8-12">
                            <Date date={props.date} textVariant="span" />
                        </PromoRow>
                    )}
                    <div className={styles.title}>
                        <PromoDangerouslyHtml tag="div" variant="subheader" color="primary" dangerouslyHtml={props.title} />
                    </div>

                    <div className={styles.subtitle}>
                        <PromoDangerouslyHtml tag="div" color="gray80" dangerouslyHtml={props.text} />
                    </div>

                    <div className={styles.badgesContainer}>
                        {Array.isArray(props.categories) &&
                            props.categories
                                .filter((item) => item !== null)
                                .map((item) => {
                                    return <PromoBadge key={item.id} caption={item.title} isInactive />;
                                })}
                    </div>
                </div>
            )}
        </a>
    );
};

BlogTile.propTypes = {
    date: PropTypes.string,
    link: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    img: PropTypes.object,
    isNewsPage: PropTypes.bool,
    categories: PropTypes.array,
};
